import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "max-w-[1113px] custom-container-forum mx-auto"
}
const _hoisted_2 = { class: "mt-8 text-2xl font-medium leading-8" }
const _hoisted_3 = {
  key: 2,
  class: "flex justify-center flex-col items-center max-w-[1113px] mx-auto"
}
const _hoisted_4 = { class: "flex flex-col gap-2" }
const _hoisted_5 = { class: "w-full" }
const _hoisted_6 = { class: "sm:w-sm md:w-md lg:w-[1008px] xl:w-[1113px]" }
const _hoisted_7 = { class: "ql-formats" }
const _hoisted_8 = { class: "ql-bold" }
const _hoisted_9 = { class: "ql-italic" }
const _hoisted_10 = { class: "ql-underline" }
const _hoisted_11 = { class: "ql-formats" }
const _hoisted_12 = {
  class: "ql-list",
  value: "ordered"
}
const _hoisted_13 = {
  class: "ql-list",
  value: "bullet"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("select", { class: "ql-align" }, null, -1)
const _hoisted_15 = { class: "ql-formats" }
const _hoisted_16 = {
  class: "ql-link",
  value: "link"
}
const _hoisted_17 = { class: "ql-code-block" }
const _hoisted_18 = { class: "flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_BreadcrumbForum = _resolveComponent("BreadcrumbForum")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Button = _resolveComponent("Button")!
  const _component_AddFileInput = _resolveComponent("AddFileInput")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.isFormLoading,
      label: _ctx.$t('labels.generic', { pt: 'Carregando...', en: 'Loading...' }),
      loaderType: "progress"
    }, null, 8, ["loader", "label"]),
    (_ctx.isTeacherOrAdmin() && !_ctx.isFormLoading)
      ? (_openBlock(), _createBlock(_component_BreadcrumbForum, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isFormLoading)
      ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirectToTopicDetail && _ctx.redirectToTopicDetail(...args))),
            class: "flex items-center gap-3 mt-6 text-base font-bold btn-simple"
          }, [
            _createVNode(_component_v_icon, {
              name: "co-arrow-left",
              width: "24",
              height: "24"
            }),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Voltar para tópico",
              en: "Go back to topic",
            })), 1)
          ]),
          _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("forum.topic.comment.form.title")), 1)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isFormLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _createElementVNode("form", {
            action: "",
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"])),
            class: "mt-6"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t("forum.topic.comment.form.label.comment")), 1),
              _createElementVNode("fieldset", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Editor, {
                    modelValue: _ctx.comment.comment,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.comment.comment) = $event)),
                    modelModifiers: { lazy: true },
                    class: _normalizeClass(["mb-3 w-[95vw] sm:w-[615px] md:w-[752px] lg:w-[1008px] xl:w-[1113px]", [
                  {
                    'border !border-red-600 rounded-md':
                      _ctx.v$.comment.comment.$error,
                  },
                ]]),
                    editorStyle: "height: 160px; max-width: inherit;"
                  }, {
                    toolbar: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _withDirectives(_createElementVNode("button", _hoisted_8, null, 512), [
                          [
                            _directive_tooltip,
                            'Bold',
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _withDirectives(_createElementVNode("button", _hoisted_9, null, 512), [
                          [
                            _directive_tooltip,
                            'Italic',
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _withDirectives(_createElementVNode("button", _hoisted_10, null, 512), [
                          [
                            _directive_tooltip,
                            'Underline',
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _withDirectives(_createElementVNode("button", _hoisted_12, null, 512), [
                          [
                            _directive_tooltip,
                            'Ordered',
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _withDirectives(_createElementVNode("button", _hoisted_13, null, 512), [
                          [
                            _directive_tooltip,
                            'Bullet',
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _hoisted_14
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives(_createElementVNode("button", _hoisted_16, null, 512), [
                          [
                            _directive_tooltip,
                            'Link',
                            void 0,
                            { bottom: true }
                          ]
                        ]),
                        _withDirectives(_createElementVNode("button", _hoisted_17, null, 512), [
                          [
                            _directive_tooltip,
                            'CodeBlock',
                            void 0,
                            { bottom: true }
                          ]
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "class"]),
                  _createElementVNode("div", null, [
                    _createVNode(_component_Errors, {
                      errors: _ctx.v$.comment.comment.$errors,
                      actualLength: _ctx.comment?.comment?.length,
                      maxLength: 700
                    }, null, 8, ["errors", "actualLength"])
                  ])
                ])
              ])
            ]),
            (!_ctx.isImageBeingEmbedded)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  type: "button",
                  onClick: _ctx.showEmbedImageComponent,
                  class: "btn-simple !p-0 !mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      name: "hi-upload",
                      class: "mr-2"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Anexar imagem",
              en: "Attach image",
            })), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_AddFileInput, {
                  key: 1,
                  class: "mt-8",
                  onOnSetImage: _ctx.setCommentImage,
                  onOnResetImage: _ctx.resetCommentImage,
                  imageSelected: _ctx.image
                }, null, 8, ["onOnSetImage", "onOnResetImage", "imageSelected"])),
            _createElementVNode("span", _hoisted_18, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.redirectToTopicDetail && _ctx.redirectToTopicDetail(...args))),
                type: "button",
                class: "btn-outline border border-h-primary-500 my-2 px-2 rounded flex items-center justify-center text-h-primary-500 font-bold w-[79px] h-8 box-border"
              }, _toDisplayString(_ctx.$t("forum.topic.comment.form.buttons.cancel")), 1),
              _createVNode(_component_Button, {
                type: "submit",
                class: "btn-primary transition-all my-2 px-2 rounded flex items-center justify-center text-white font-bold w-[79px] h-[32px] box-border"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("forum.topic.comment.form.buttons.publish")), 1)
                ]),
                _: 1
              })
            ])
          ], 32)
        ]))
      : _createCommentVNode("", true)
  ]))
}